import { PortfolioPosition } from 'portfolio/PortfolioSelection';

export interface PositionEntryInput {
    pills: string[];
}

export interface PositionEntryState {
    /*
     * The position entered in the input
     * Needed in redux so it can be cleared by middleware
     */
    positionInput: PositionEntryInput;
    /*
     * The active position, after the debounce
     */
    position?: PortfolioPosition;
}

export const initialPositionEntryState: PositionEntryState = {
    positionInput: { pills: [] },
};
